import { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import getSlug from 'speakingurl';

import useResponsive from '../../../utils/responsive';

const FaqTabs = (props) => {
   
    const { sections } = props;
    const [value, setActiveValue] = useState(0);
    const { isMobile, isTablet } = useResponsive();

    const getSectionHeader = () => {
        return _.map(sections, (section, index) => {
            const headerName = _.get(section, 'section_header');
            const headerNameSlug = getSlug(headerName);
            return (
                <Tab
                    key={index}
                    label={headerName}
                    wrapped
                    component="a"
                    onMouseEnter={() => setActiveValue(index)}
                    href={`#${headerNameSlug}`}
                />
            );
        });
    };

    if (isMobile || isTablet) {
        return null;
    }
    return (
        <div className='faq-tab-container'>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                indicatorColor="secondary"
                classes={{ indicator: 'faq-tab-indicator' }}
            >
                {getSectionHeader()}
            </Tabs>
        </div>
    );
};

export default FaqTabs;

FaqTabs.propTypes = {
    sections: PropTypes.array,
};
